import { render, staticRenderFns } from "./BuyerElement.vue?vue&type=template&id=71853ec1"
import script from "./BuyerElement.vue?vue&type=script&lang=js"
export * from "./BuyerElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports